import { lazy, Suspense } from 'react';
const CardGroups = lazy(() => import("./CardGroups"));
const Intro = lazy(() => import("./Intro"));
function LandingPage() {
    return (
        <div style={{ direction: 'rtl' }}>
            <Suspense fallback={<div>Loading...</div>}>
                <Intro />
                <CardGroups />
            </Suspense>
        </div>
    )
}
export default LandingPage;